(function(){
  "use strict";
  var scrim = function(){ return document.querySelector('[data-scrim]'); };
  function lock(){ document.body.style.overflow='hidden'; }
  function unlock(){ document.body.style.overflow=''; }

  /* ---------- Inventory / cart toast ---------- */
  (function(){ var s=document.createElement('style'); s.textContent='.sk-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:#1c1c1c;color:#fff;padding:13px 20px;border-radius:12px;font-size:14px;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.25);z-index:200;opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;max-width:90vw;text-align:center}.sk-toast.show{opacity:1;transform:translateX(-50%) translateY(0)}'; document.head.appendChild(s); })();
  function skCartToast(msg){ var t=document.querySelector('[data-sk-toast]'); if(!t){ t=document.createElement('div'); t.setAttribute('data-sk-toast',''); t.className='sk-toast'; document.body.appendChild(t); } t.textContent=msg; t.classList.add('show'); clearTimeout(t._tm); t._tm=setTimeout(function(){ t.classList.remove('show'); }, 4000); }
  window.skCartToast = skCartToast;

  /* ---------- Mobile nav ---------- */
  var mnav = document.querySelector('[data-mnav]');
  function openNav(){ mnav&&mnav.classList.add('open'); var s=scrim(); s&&s.classList.add('open'); lock(); }
  function closeNav(){ mnav&&mnav.classList.remove('open'); var s=scrim(); s&&s.classList.remove('open'); unlock(); }
  document.querySelectorAll('[data-open-mnav]').forEach(function(b){ b.addEventListener('click', openNav); });
  document.querySelectorAll('[data-close-mnav]').forEach(function(b){ b.addEventListener('click', closeNav); });

  document.querySelectorAll('[data-macc-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){ var p=btn.nextElementSibling; if(p){ p.style.display=(p.style.display==='block')?'none':'block'; } });
  });

  /* ---------- Mega menu (desktop) ---------- */
  var header=document.querySelector('.site-header');
  if(header){
    var panel=header.querySelector('.mega[data-mega-panel]');
    function closeMega(){ panel&&panel.classList.remove('open'); }
    header.querySelectorAll('.nav-link[data-mega]').forEach(function(t){
      t.addEventListener('mouseenter', function(){ panel&&panel.classList.add('open'); });
      t.addEventListener('focus', function(){ panel&&panel.classList.add('open'); });
    });
    header.querySelectorAll('.nav-link:not([data-mega]), .header-actions, .logo').forEach(function(el){
      el.addEventListener('mouseenter', closeMega);
      el.addEventListener('focusin', closeMega);
    });
    if(panel){
      header.addEventListener('mouseleave', closeMega);
      panel.addEventListener('mouseenter', function(){ panel.classList.add('open'); });
      panel.addEventListener('mouseleave', closeMega);
    }
  }

  /* ---------- Predictive search ---------- */
  var sov = document.querySelector('[data-search-overlay]');
  if(sov){
    var sInput = sov.querySelector('[data-search-input]');
    var sResults = sov.querySelector('[data-search-results]');
    function openSearch(){ sov.hidden=false; requestAnimationFrame(function(){ sov.classList.add('open'); }); lock(); setTimeout(function(){ sInput&&sInput.focus(); }, 80); }
    function closeSearch(){ sov.classList.remove('open'); unlock(); setTimeout(function(){ sov.hidden=true; }, 250); }
    document.querySelectorAll('[data-open-search]').forEach(function(b){ b.addEventListener('click', openSearch); });
    document.querySelectorAll('[data-close-search]').forEach(function(b){ b.addEventListener('click', closeSearch); });
    sov.addEventListener('click', function(e){ if(e.target===sov) closeSearch(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !sov.hidden) closeSearch(); });
    var sTimer=null, lastQ='';
    function sroot(){ return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
    function fetchSuggest(q){
      var url = sroot()+'search/suggest?q='+encodeURIComponent(q)+'&section_id=predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function(r){ return r.text(); }).then(function(html){
        if(q!==lastQ) return;
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var inner=tmp.querySelector('.ps-wrap');
        if(sResults) sResults.innerHTML = inner ? inner.innerHTML : '';
      }).catch(function(){});
    }
    if(sInput){
      sInput.addEventListener('input', function(){
        clearTimeout(sTimer);
        var q=sInput.value.trim(); lastQ=q;
        if(q.length<2){ if(sResults) sResults.innerHTML=''; return; }
        sTimer=setTimeout(function(){ fetchSuggest(q); }, 220);
      });
    }
  }

  /* ---------- Filters drawer (mobile) ---------- */
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-open-filters]')){ var f=document.getElementById('filters'),fs=document.querySelector('.filter-scrim'); f&&f.classList.add('open'); fs&&fs.classList.add('open'); }
    if(e.target.closest('[data-close-filters]')){ var f2=document.getElementById('filters'),fs2=document.querySelector('.filter-scrim'); f2&&f2.classList.remove('open'); fs2&&fs2.classList.remove('open'); }
  });

  /* ---------- Announcement rotate ---------- */
  var items=document.querySelectorAll('.announce .ann-item');
  if(items.length>1){ var i=0; setInterval(function(){ items[i].classList.remove('on'); i=(i+1)%items.length; items[i].classList.add('on'); },3500); }

  /* ---------- CART DRAWER ---------- */
  function drawer(){ return document.querySelector('[data-cart]'); }
  function openCart(){ var d=drawer(); d&&d.classList.add('open'); var s=scrim(); s&&s.classList.add('open'); lock(); }
  function closeCart(){ var d=drawer(); d&&d.classList.remove('open'); var s=scrim(); s&&s.classList.remove('open'); unlock(); }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-scrim]')){ closeCart(); closeNav(); }
    if(e.target.closest('[data-open-cart]')){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-close-cart]')){ e.preventDefault(); closeCart(); }
  });

  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=n; el.style.display=n?'grid':'none'; }); }

  function refreshDrawer(open){
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html=data['cart-drawer']; if(!html) return;
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var freshBody=tmp.querySelector('[data-cart-body]');
        var curBody=document.querySelector('[data-cart-body]');
        if(freshBody && curBody){ curBody.innerHTML=freshBody.innerHTML; }
        if(open) openCart();
      });
  }

  function cartJson(){ return fetch('/cart.js').then(function(r){return r.json();}); }
  function updateCountFromCart(){ cartJson().then(function(c){ setCount(c.item_count); }); }

  function change(key, qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ return r.json().then(function(cart){ return {status:r.status, cart:cart}; }); })
      .then(function(res){
        var cart=res.cart;
        if(res.status>=400){ skCartToast((cart && cart.description) || 'Could not update quantity.'); }
        else if(qty>0 && cart && cart.items){ for(var i=0;i<cart.items.length;i++){ if(cart.items[i].key===key && cart.items[i].quantity<qty){ skCartToast('Only '+cart.items[i].quantity+' left in stock.'); break; } } }
        return refreshDrawer(false);
      }).then(updateCountFromCart);
  }
  function addId(variantId, qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variantId,quantity:qty||1})})
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
      .then(function(){ return refreshDrawer(true); }).then(updateCountFromCart)
      .catch(function(err){ skCartToast((err && err.description) || 'Could not add to cart.'); });
  }

  document.addEventListener('click', function(e){
    var inc=e.target.closest('[data-inc]'); var dec=e.target.closest('[data-dec]');
    var rm=e.target.closest('[data-remove]'); var addv=e.target.closest('[data-add-variant]');
    if(inc||dec){
      var line=e.target.closest('.cart-line'); var span=line && line.querySelector('.stepper span');
      var cur=span?parseInt(span.textContent,10):1;
      var key=(inc||dec).getAttribute(inc?'data-inc':'data-dec');
      change(key, inc?cur+1:Math.max(0,cur-1));
    }
    if(rm){ change(rm.getAttribute('data-remove'),0); }
    if(addv){ addId(addv.getAttribute('data-add-variant'),1); }
  });

  document.querySelectorAll('form[action$="/cart/add"], form.product-form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn=form.querySelector('[name="add"]'); if(btn){ btn.setAttribute('disabled','disabled'); }
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
        .then(function(){ return refreshDrawer(true); })
        .then(updateCountFromCart)
        .catch(function(err){ if(err && err.description){ skCartToast(err.description); } else { form.submit(); } })
        .finally(function(){ if(btn){ btn.removeAttribute('disabled'); } });
    });
  });
})();


/* ===== Product-card hover: second image + colour-swatch variant swap (Sunkissed) ===== */
(function(){
  if(window.__skCardHover) return; window.__skCardHover=1;
  var CSS='.product-card .media .sk-ph-2{opacity:0;transition:opacity .35s ease;pointer-events:none;}'
    +'@media (hover:hover){.product-card:hover .media .sk-ph-2{opacity:1;}}'
    +'.product-card[data-swatch-engaged] .media .sk-ph-2{opacity:0 !important;}'
    +'.product-card a.swatch,.product-card button.swatch{box-sizing:border-box;-webkit-appearance:none;appearance:none;border:0;padding:0;margin:0;cursor:pointer;display:inline-block;text-decoration:none;}'
    +'.product-card .swatch.is-active{box-shadow:0 0 0 2px #fff,0 0 0 4px var(--ink,#1c1c1c);}';
  var st=document.createElement('style'); st.setAttribute('data-card-hover',''); st.appendChild(document.createTextNode(CSS)); document.head.appendChild(st);
  function primaryOf(card){ return card.querySelector('[data-card-primary]'); }
  function rememberOrig(img){ if(img && !img.getAttribute('data-orig')){ img.setAttribute('data-orig', img.getAttribute('src')); } }
  document.addEventListener('click', function(e){
    var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
    var card=sw.closest('.product-card'); if(!card) return;
    e.preventDefault();
    var img=primaryOf(card); rememberOrig(img);
    var src=sw.getAttribute('data-swatch-img'); var url=sw.getAttribute('data-swatch-url'); var vid=sw.getAttribute('data-swatch-variant');
    if(img && src){ img.src=src; }
    if(url){ card.querySelectorAll('a.media-link, .info a[href]').forEach(function(a){ a.setAttribute('href', url); }); }
    if(vid){ var qa=card.querySelector('[data-add-variant]'); if(qa){ qa.setAttribute('data-add-variant', vid); } }
    card.setAttribute('data-swatch-engaged','1');
    card.querySelectorAll('.swatch.is-active').forEach(function(x){ x.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });
  if(window.matchMedia && window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mouseover', function(e){
      var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
      var card=sw.closest('.product-card'); if(!card) return; var img=primaryOf(card); if(!img) return;
      if(card.querySelector('.swatch.is-active')) return;
      rememberOrig(img); img.src=sw.getAttribute('data-swatch-img'); card.setAttribute('data-swatch-engaged','1');
    });
    document.addEventListener('mouseout', function(e){
      var sw=e.target.closest('.product-card .swatch[data-swatch-img]'); if(!sw) return;
      var card=sw.closest('.product-card'); if(!card) return; var img=primaryOf(card); if(!img) return;
      if(card.querySelector('.swatch.is-active')) return;
      var orig=img.getAttribute('data-orig'); if(orig){ img.src=orig; } card.removeAttribute('data-swatch-engaged');
    });
  }
})();
